module.exports = __webpack_public_path__ + "static/media/sound.abf5aa80.mp3";